import { render } from "./ProductosList.vue?vue&type=template&id=a6e7bac2&scoped=true"
import script from "./ProductosList.vue?vue&type=script&lang=js"
export * from "./ProductosList.vue?vue&type=script&lang=js"

import "./ProductosList.vue?vue&type=style&index=0&id=a6e7bac2&lang=css"
import "./ProductosList.vue?vue&type=style&index=1&id=a6e7bac2&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6e7bac2"]])

export default __exports__